// extracted by mini-css-extract-plugin
module.exports = {"miniSpinner":"Spinners_miniSpinner__3xu4P","mini-spinner":"Spinners_mini-spinner__rOuUR"};